<script>
import { fandomBasicMixin, fandomExtendedMixin } from 'src/modules/fandom_mixins_module.js';
import Intersect from 'vue-intersect';
import { get } from "lodash";
import { mqLess } from 'src/modules/viewport_module';

export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin],
  components: {
    Intersect
  },
  data: function() {
    return {
    };
  },
  methods: {
    mqLess: mqLess,
    getContentResponsiveImageURL: Fandom.getContentResponsiveImageURL,
    toggleVideo(status) {
      if (status) {
        this.video.muted = true;
        this.video.play();
      } else {
        this.video.pause();
      }
    },
    mayToggleVideoPopup() {
      if (this.videoPopupPresent) {
        Vue.set(globalState, "videoPopupContent", { content: this.content, containerContent: this.containerContent });
      }
    },
    handleClick() {
      window.scrollTo(0, this.$el.scrollHeight);
    }
  },
  computed: {
    videoPopupPresent() {
      return Fandom.exists(this.content.play) || Fandom.exists(this.content.embed_media);
    },
    columnClasses() {
      const size = get(this, ["content", "width"], 8);
      return `col-md-${size}`;
    },
    video() {
      return $(this.$refs.video)[0];
    },
    height() {
      if (this.mqLess("sm")) {
        return {
          class: "mh-100vh-header",
          style: {}
        };
      } else {
        return {
          class: (this.content.height ? "" : "mh-100vh-header"),
          style: {
            "min-height": this.content.height
          }
        };
      }
    },
    backgroundVideoUrl() {
      const videoDesktop = get(this, "content.background_video.url", false);
      return get(globalState, "viewport.xs", false) ? get(this, "content.background_video_mobile.url", videoDesktop) : videoDesktop;
    }
  }
};
</script>

<template>
  <div
    v-easyadmin="easyadminId"
    class="h-100vh-header"
    :class="[contentType, paddingY, {'cursor-pointer': videoPopupPresent}]" 
    v-if="isContentVisibleToUser()" 
    :style="[theme, {'background-color': content.background_color}]"
    @click="mayToggleVideoPopup()" 
    heading-media-component
  >
    <div :style="{'background-image': getContentResponsiveImageURL('background_image')}" class="bg-cover-center">
      <intersect @enter="toggleVideo(true)" @leave="toggleVideo(false)" v-if="backgroundVideoUrl">
        <div class="position-absolute-center">
          <video loop muted webkit-playsinline playsinline autoplay ref="video" class="w-100 h-100">
            <source :src="expandUrl(backgroundVideoUrl)" type="video/mp4">
          </video>
        </div>
      </intersect>
      <div class="h-100vh-header position-relative" :class="content.propagate_container ? 'container-fluid' : 'container'">
        <div @click.stop="handleClick" class="show-more-icon position-absolute">
          <i class="fal fa fa-chevron-down"></i>
        </div>
        <div class="h-100 row justify-content-center align-items-center">
          <div
            class="text-section-container align-items-center d-flex justify-content-center flex-column content-container"
            :class="[columnClasses, height.class]"
            :style="height.style"
            >
            <text-section class="w-100" :content="content" :opt-container-content="containerContent"></text-section>
            <div v-if="videoPopupPresent">
              <div class="play-icon-container my-3">
                <i class="fas fa-play ml-1"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
[heading-media-component] {
  position: relative;

  background-color: var(--theme-background);
  color: var(--theme-color);

  ::v-deep img.icon {
    width: 16rem;

    @include media-breakpoint-down(md) {
      width: 12rem;
    }
  }

  @include media-breakpoint-up(xl) {
    .text-section-container {
      min-height: auto !important;
    }
  }

  video {
    object-fit: cover;
  }

  .show-more-icon {
    left: 50%;
    right: 50%;
    bottom: 0;
    color: white;
    font-size: 1.5rem;
  }

  .play-icon-container {
    position: relative;
    font-size: 1.75rem;

    &:before {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      border-radius: 100%;
      border: 3px solid $primary;
      animation: playIconAnimation 2s infinite;
    }
  }

  @-webkit-keyframes playIconAnimation {
    0% {
      -webkit-transform: scale(1);
      opacity: 1;
    }
    100% {
      -webkit-transform: scale(1.4);
      opacity: 0;
    }
  }

  @keyframes playIconAnimation {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    100% {
      transform: scale(1.4);
      opacity: 0;
    }
  }
}
</style>
